<script>
    import { _ } from "svelte-i18n";
  </script>


  <section class="text-gray-600 body-font">
    
    <div class="container px-5 py-24 mx-auto">
      <div class="text-center mb-20">
        <h1 class="sm:text-3xl text-2xl font-medium title-font text-gray-900">{$_("partners.title", {
          default: "I nostri partners",
        })}</h1>

        <div class="flex mt-6 justify-center">
        </div>
      </div>

      

        <div class="flex flex-wrap -m-4 text-center">
            <div class="p-4 md:w-1/4 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-5 flex-shrink-0">
                <img alt="Kemper" class=" ml-4 w-20 h-20 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Kemper.jpg">
              </div>
    
              <div class="flex-grow mt-5">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">Kemper Srl</h2>
                <p class="leading-relaxed text-base">{$_("partners.desc1", {
                  default: "Prodotti Chimici per l’Areonautica",
                })}</p>
                
              </div>
            </div>



          <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-5 flex-shrink-0">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-10 h-10" viewBox="0 0 24 24">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>

          <div class="flex-grow mt-5">
            <h2 class="text-gray-900 text-lg title-font font-medium mb-3">Trescal Srl</h2>
            <p class="leading-relaxed text-base ">{$_("partners.desc2", {
              default: "Sistemi di Misurazione e Taratura",
            })}</p>
            
          </div>
          </div>



          <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-5 flex-shrink-0">
              <img alt="Leonardo" class=" ml-4 w-20 h-20 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Leonardo.jpg">
            </div>
  
            <div class="flex-grow mt-5">
              <h2 class="text-gray-900 text-lg title-font font-medium mb-3">Leonardo Company Spa</h2>
              <p class="leading-relaxed text-base">{$_("partners.desc3", {
                default: "Divisione Velivoli",
              })}</p>
              
            </div>
          </div>




          <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-5 flex-shrink-0">
                <img alt="aeroservizi" class=" ml-4 w-20 h-20 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/aeroservizi.png">
              </div>
  
            <div class="flex-grow mt-5">
              <h2 class="text-gray-900 text-lg title-font font-medium mb-3">P.A.F. Aeroservizi Srl</h2>
              <p class="leading-relaxed text-base ">{$_("partners.desc4", {
                default: "P.A.F. Aeroservizi Srl - Revisione e Manutenzione Eliche e Regolatori Elica",
              })}</p>
              
            </div>
          </div>
          
        </div>
    













  </section>
  